var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "save") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Steps-in-report-creation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBook-Air-13\"-Copy-27",
    transform: "translate(-1002.000000, -120.000000)",
    fill: "#212129",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "save",
    transform: "translate(1002.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7583062,5.24166667 L9.75831538,0.241666667 C9.68152355,0.166707527 9.59097654,0.107285943 9.49164921,0.0666666667 C9.38832745,0.0246808381 9.278157,0.00208173142 9.1666498,0 L2.5,0 C1.11928607,0 0,1.11928813 0,2.5 L0,12.5 C0,13.8807119 1.11928607,15 2.5,15 L12.499977,15 C13.8806863,15 14.9999864,13.8807119 14.9999864,12.5 L14.9999864,5.83333333 C15.001253,5.61183085 14.9142947,5.39893236 14.7583062,5.24166667 Z M4.9999908,1.66666667 L8.333318,1.66666667 L8.333318,3.33333333 L4.9999908,3.33333333 L4.9999908,1.66666667 Z M9.9999908,13.3333333 L4.9999908,13.3333333 L4.9999908,10.8333333 C4.9999908,10.373096 5.37308616,10 5.8333226,10 L9.1666498,10 C9.62688625,10 9.9999908,10.373096 9.9999908,10.8333333 L9.9999908,13.3333333 Z M13.3333088,12.5 C13.3333088,12.9602373 12.9602135,13.3333333 12.499977,13.3333333 L11.6666452,13.3333333 L11.6666452,10.8333333 C11.6666452,9.45262146 10.5473591,8.33333333 9.1666498,8.33333333 L5.8333226,8.33333333 C4.45261327,8.33333333 3.3333272,9.45262146 3.3333272,10.8333333 L3.3333272,13.3333333 L2.4999954,13.3333333 C2.03975896,13.3333333 1.6666636,12.9602373 1.6666636,12.5 L1.6666636,2.5 C1.6666636,2.03976271 2.03975896,1.66666667 2.4999954,1.66666667 L3.3333272,1.66666667 L3.3333272,4.16666667 C3.3333272,4.62690396 3.70642256,5 4.1666636,5 L9.1666498,5 C9.62688625,5 9.9999816,4.62690396 9.9999816,4.16666667 L9.9999816,2.84166667 L13.3333088,6.175 L13.3333088,12.5 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.377526677378eb81acb99766bdaf319c.svg";
export { ForwardRef as ReactComponent };